import { ApplicationModuleTabs, FacilityModuleTabs } from '../../enums/permission-module.enum';
import { Tab } from '../../models/tab.model';

export const facilityApplicationTabs: Tab[] = [
	{
		name: 'Summary',
		path: `:id/summary`,
		permissionId: ApplicationModuleTabs.Summary,
	},
	{
		name: 'Facilities',
		path: `:id/facilities`,
		permissionId: ApplicationModuleTabs.Facilities,
	},
	{
		name: 'Facility Contract',
		path: `:id/facility-contract`,
		permissionId: ApplicationModuleTabs.FacilityContract,
	},
	{
		name: 'Initial Visit',
		path: `:id/initial-visit`,
		permissionId: ApplicationModuleTabs.InitialVisit,
	},
	{
		name: 'Contacts',
		path: `:id/contacts`,
		permissionId: ApplicationModuleTabs.Contacts,
	},
	{
		name: 'Tasks',
		path: `:id/tasks`,
		permissionId: ApplicationModuleTabs.Tasks,
	},
	{
		name: 'Application Info',
		path: `:id/application-info`,
		permissionId: ApplicationModuleTabs.ApplicationInfo,
	},
	{
		name: 'Referral',
		path: `:id/referral`,
		permissionId: ApplicationModuleTabs.Referral,
		hidden: true,
	},
	{
		name: 'Products',
		path: `:id/products`,
		permissionId: ApplicationModuleTabs.Products,
	},
	{
		name: 'Ingredients',
		path: `:id/ingredients`,
		permissionId: ApplicationModuleTabs.Ingredients,
	},
	{
		name: 'History',
		path: ':id/history',
		permissionId: FacilityModuleTabs.History,
	},
	{
		name: 'Notes',
		path: `:id/notes`,
		permissionId: FacilityModuleTabs.Notes,
	},
	{
		name: 'Audit Trail',
		path: `:id/audit-trail`,
	},
];
